import { render, staticRenderFns } from "./homeEdit.vue?vue&type=template&id=196a98b4&"
import script from "./homeEdit.vue?vue&type=script&lang=js&"
export * from "./homeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports